import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grids" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listA, (item, i) => {
      return (_openBlock(), _createBlock(_component_v_btn, {
        color: "primary",
        onClick: ($event: any) => (_ctx.clicked(item)),
        disabled: !_ctx.hasChild(item),
        key: i,
        class: _normalizeClass(["grid-item", { 'custom-disabled-btn': !_ctx.hasChild(item) }])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(item), 1)
        ]),
        _: 2
      }, 1032, ["onClick", "disabled", "class"]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listI, (item, i) => {
      return (_openBlock(), _createBlock(_component_v_btn, {
        color: "primary",
        onClick: ($event: any) => (_ctx.clicked(item)),
        disabled: !_ctx.hasChild(item),
        key: i,
        class: _normalizeClass(["grid-item", { 'custom-disabled-btn': !_ctx.hasChild(item) }])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(item), 1)
        ]),
        _: 2
      }, 1032, ["onClick", "disabled", "class"]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listU, (item, i) => {
      return (_openBlock(), _createBlock(_component_v_btn, {
        color: "primary",
        onClick: ($event: any) => (_ctx.clicked(item)),
        disabled: !_ctx.hasChild(item),
        key: i,
        class: _normalizeClass(["grid-item", { 'custom-disabled-btn': !_ctx.hasChild(item) }])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(item), 1)
        ]),
        _: 2
      }, 1032, ["onClick", "disabled", "class"]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listE, (item, i) => {
      return (_openBlock(), _createBlock(_component_v_btn, {
        color: "primary",
        onClick: ($event: any) => (_ctx.clicked(item)),
        disabled: !_ctx.hasChild(item),
        key: i,
        class: _normalizeClass(["grid-item", { 'custom-disabled-btn': !_ctx.hasChild(item) }])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(item), 1)
        ]),
        _: 2
      }, 1032, ["onClick", "disabled", "class"]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listO, (item, i) => {
      return (_openBlock(), _createBlock(_component_v_btn, {
        color: "primary",
        onClick: ($event: any) => (_ctx.clicked(item)),
        disabled: !_ctx.hasChild(item),
        key: i,
        class: _normalizeClass(["grid-item", { 'custom-disabled-btn': !_ctx.hasChild(item) }])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(item), 1)
        ]),
        _: 2
      }, 1032, ["onClick", "disabled", "class"]))
    }), 128))
  ]))
}